import type { LoaderFunctionArgs } from "@remix-run/server-runtime";
import { logger } from "@sentry/remix";
export async function loader({ request, params }: LoaderFunctionArgs) {
	return null;
}

export default function NoMatch() {
	return <>
		<div>Not found</div>
	</>
}